module.exports = __webpack_public_path__ + "static/media/55_000080.a3b94ff8.jpg";